// util to check if we are on nextjs via presence of 'next/image'
const isNextJS = () => {
    let result = false;
    try {
        require.resolve('next/image');
        result = true;
    }
    catch (e) {
        // do nothing
    }
    return result;
};

export { isNextJS };
//# sourceMappingURL=utils.js.map
